import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const useHeaderState = (token) => {
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [showManageProfiles, setShowManageProfiles] = useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [canPost, setCanPost] = useState(false);
  const [unreadMessages, setUnreadMessages] = useState(0);
  const [unreadNotifications, setUnreadNotifications] = useState(0);

  const checkSubscriptionStatus = useCallback(async () => {
    if (!token) return;
    try {
      const response = await axios.get(`${API_URL}/api/subscriptions/can-post`, {
        withCredentials: true
      });
      setCanPost(response.data.can_post);
    } catch (error) {
      console.error('Error checking subscription:', error);
      setCanPost(false);
    }
  }, [token]);

  const fetchNotifications = useCallback(async () => {
    if (!token) return;
    try {
      const response = await axios.get(`${API_URL}/api/realtime/notifications`, {
        withCredentials: true
      });
      setUnreadMessages(response.data.unread_messages || 0);
      setUnreadNotifications(response.data.unread_notifications || 0);
    } catch (error) {
      console.error('Error fetching notifications:', error);
    }
  }, [token]);

  useEffect(() => {
    checkSubscriptionStatus();
    fetchNotifications();
    const interval = setInterval(fetchNotifications, 30000);
    return () => clearInterval(interval);
  }, [token, checkSubscriptionStatus, fetchNotifications]);

  const handleUploadClick = useCallback(() => {
    if (canPost) {
      setShowUploadModal(true);
    } else {
      setShowUpgradeModal(true);
    }
  }, [canPost]);

  useEffect(() => {
    const handleOpenUpload = () => {
      if (canPost) {
        setShowUploadModal(true);
      } else {
        setShowUpgradeModal(true);
      }
    };
    window.addEventListener('openUploadModal', handleOpenUpload);
    return () => window.removeEventListener('openUploadModal', handleOpenUpload);
  }, [canPost]);

  return {
    isSearchOpen,
    setIsSearchOpen,
    showManageProfiles,
    setShowManageProfiles,
    showUploadModal,
    setShowUploadModal,
    showUpgradeModal,
    setShowUpgradeModal,
    showMobileMenu,
    setShowMobileMenu,
    canPost,
    unreadMessages,
    unreadNotifications,
    handleUploadClick,
    checkSubscriptionStatus
  };
};
